<template lang="pug">
  div
    .gonots(v-if="hasStatus")
      .gonots--bar(:class="barColor")
        .container-fluid
          .row.no-gutters.align-items-center
            .col-auto: span.gonots--icon
              font-awesome-icon(v-if="nf2fStatus === 0 || nf2fStatus === 88", icon="check")
              font-awesome-icon(v-else, icon="exclamation-triangle")
            .col
              .row.align-items-center
                  template(v-if="isDoingEform")
                    .col
                      | <strong>eInvest Go Application:</strong> Your eInvest Go application is only partially completed. <a href="#" @click.prevent="GO_TO_APPLICATION_PAGE">Click here</a> to complete your application process.

                  template(v-if="nf2fStatus === 4")
                    .col
                      | <strong>eInvest Go Application:</strong> Your eInvest Go application is still pending. <a href="#" @click.prevent="GO_TO_APPLICATION_PAGE">Click here</a> to make the necessary payment and complete your application process.

                  template(v-if="nf2fStatus === 0")
                    .col
                      | <strong>eInvest Go Application:</strong> Your eInvest Go application is received and will now be reviewed by our operational team. Thank you.
                  
                  template(v-if="nf2fStatus === 5")
                    .col-lg-9 <strong>eInvest Go Application:</strong> Application status - Resubmission of document(s) required.
                    .col-lg-3.text-lg-right: <button class="button button-warning" href="#" @click.prevent="GO_TO_APPLICATION_PAGE">Resubmit Now</button>

                  template(v-if="nf2fStatus === 88")
                    .col
                      | <strong>eInvest Go Application:</strong> Your eInvest Go application is approved, and your account is now ready. Congratulations!

                  template(v-if="nf2fStatus === 999")
                    .col
                      | <strong>eInvest Go Application:</strong> Your eInvest Go application has unfortunately been rejected after our reviews. <a href="#" @click.prevent="GO_TO_APPLICATION_PAGE">Click here</a> for more options and solutions.

</template>


<script>
  import requestHandlers from '@/mixins/requestHandlers';

  export default {
    name: 'GoNotification',

    mixins: [requestHandlers],

    data: () => ({
      hasStatus: false,
      nf2fStatus: 0,
      // 99, 1, 2, 3 --> still doing the eForm
          // 99 suspend account,
          // 1 eform
          // 2 Bureau File verification
          // 3 KBQ
      // 4 --> payment
      // 0 --> submitted, pending approval
      // 5 --> reupload required
      // 999 --> application rejected
      // 88 --> account opened (probably will never see this)
    }),


    computed: {
      isDoingEform() {
        return [99, 1, 2, 3].findIndex(i => i === this.nf2fStatus) > -1;
      },

      barColor() {
        return {
          'is-warning': this.isDoingEform || this.nf2fStatus === 4 || this.nf2fStatus === 5,
          'is-danger': this.nf2fStatus === 999,
          'is-success': this.nf2fStatus === 88 || this.nf2fStatus === 0,
        }
      },
    },

    methods: {
      async FETCH_DRAFT() {
        try {
          this.REQUEST_INIT();

          // Hit retrieveDraft to get draftId

          // Production
          //let draftRes = await this.$axios.get('/nf2f/RetrieveDraft');

          // Staging
          let draftRes = await this.$axios.get('/nf2f/RetrieveDraft',  { params: { userId: "raeZx3T_p" } });          

          let { DraftId: draftId  } = draftRes.data;

          // Using the draftId, get the nf2f status
          let statusRes = await this.$axios.get('/nf2f/GetCurrentStatus', { params: { draftId } });
          this.nf2fStatus = statusRes.data.statusCode;

          this.hasStatus = true;

        } catch (error) {
          this.HANDLE_ERROR_GENERIC(error);

        } finally {
          this.REQUEST_FINALLY();

        }
      },

      GO_TO_APPLICATION_PAGE() {
        this.$router.push({ name: 'goRegistration' });
      }
    },

    created() {
      this.FETCH_DRAFT();
    }
  }

</script>



<style lang="scss">
  .gonots--icon {
    margin-right: 10px;
  }
  .gonots--bar {
    padding: 13px 15px 13px;

    @include MQ(MD) {
      padding: 12px 5px 12px;
    }

    &.is-warning {
      color: #664d03;
      background: #fff9e6;
      border-bottom: 1px solid #ffecb5;
      a {
        color: #664d03;
      }
    }
    &.is-danger {
      color: #721c24;
      background: #f8d7da;
      border-bottom: 1px solid #f5c6cb;
      a {
        color: #721c24;
      }
    }
    &.is-success {
      color: #155724;
      background: #d4edda;
      border-bottom: 1px solid #d4edda;
      a {
        color: #155724;
      }
    }

    a { 
      @include primaryFont600;
      text-decoration: underline;
    }
  }

</style>